import React, { ComponentType } from 'react';
import { ApolloConsumer } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

export interface IWithApolloClient {
  apolloClient?: ApolloClient<InMemoryCache>;
}

const withApolloClient = <T extends {}>(Component: ComponentType<T & IWithApolloClient>) => (
  props: T,
) => (
  <ApolloConsumer>
    {(client: ApolloClient<InMemoryCache>) => <Component {...props} apolloClient={client} />}
  </ApolloConsumer>
);

export { withApolloClient };
